import { useState } from 'react';
import { PrimaryButton, SecondaryButton } from '@client/new/components/button';
import { Modal } from '@client/new/components/Modal/Modal';
import { LibraryVideo } from '../videos.domain';
import VideoThumbnailSelect from './VideoThumbnailSelect';

/**
 * This components is used to change the thumbnail of a video.
 * It has to work with media: Video and support both Mux and S3 videos.
 * We get just URL to .m3u8 steam like "https://stream.mux.com/wWh00HIoCt8UCYU00jNt00Xf1X9axSYPGX200qjV3YO8027E.m3u8"
 * or to .mp4 file so need to use react-player to display it.
 * s3 videos are vertical for mobile consumption.
 * Mux videos are horizontal for TV consumption.
 */

export type ChangeThumbnailModalProps = {
  isOpen: boolean;
  onClose: () => void;
  media: LibraryVideo;
  onSave: (timeInSeconds: number) => void;
};
export function ChangeThumbnailModal(props: ChangeThumbnailModalProps) {
  const [selectedSecond, setSelectedSecond] = useState(0);
  const handleThumbnailChange = (timeInSeconds: number) => {
    setSelectedSecond(timeInSeconds);
  };

  const handleSaveClick = () => {
    props.onSave(selectedSecond);
    props.onClose();
  };

  return (
    <Modal
      title="Change thumbnail"
      height="auto"
      sx={{ maxWidth: 800 }}
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <VideoThumbnailSelect
        media={props.media}
        onChange={handleThumbnailChange}
      />
      <div className="flex justify-end">
        <div className="flex gap-4">
          <SecondaryButton
            style={{ backgroundColor: 'white', color: 'black' }}
            onClick={props.onClose}
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton onClick={handleSaveClick}> Save </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
}
